// These should reference the actual build platform name
// from the electron builder.
export enum OS {
  MAC = 'mac',
  WIN = 'win',
  LINUX = 'linux'
}

export enum MobileOS {
  IOS = 'ios',
  ANDROID = 'android',
  WINDOWS_PHONE = 'windows'
}
